import { Chip, Stack, Tooltip, Typography } from '@mui/material';

type InviteStatus = 'applied' | 'invited';

type SelectedCandidateProfileNameCellProps = {
  name: string;
  inviteStatus?: InviteStatus | null;
};

export const SelectedCandidateProfileNameCell = ({
  name,
  inviteStatus
}: SelectedCandidateProfileNameCellProps) => {
  if (!inviteStatus) {
    return <>{name}</>;
  }

  const badgeLabel =
    inviteStatus === 'applied' ? 'Already applied' : 'Already invited';

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography
        sx={{
          textDecoration: 'line-through',
          textDecorationSkipInk: 'none'
        }}
      >
        {name}
      </Typography>
      <Tooltip
        title="The candidate will not be included in this invitation list"
        placement="top"
        arrow
      >
        <Chip label={badgeLabel} size="small" color="error" />
      </Tooltip>
    </Stack>
  );
};
